import { api, handleAxiosError } from '@/lib/axios';

export const reportReference = {
  getAllInstansi: (params?: { jenis_kelembagaan?: string }) => ({
    queryKey: ['report-reference-instansi', params],
    queryFn: async () => {
      try {
        const response = await api.get('/report/reference/instansi', {
          params
        });
        return response.data;
      } catch (error) {
        throw handleAxiosError(error);
      }
    }
  })
};
